import { render, staticRenderFns } from "./BtnEmitirDeclaracaoCursos.vue?vue&type=template&id=a2174ea6&"
import script from "./BtnEmitirDeclaracaoCursos.vue?vue&type=script&lang=js&"
export * from "./BtnEmitirDeclaracaoCursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports